import React, { useState, useEffect, useRef } from 'react';
import account from '../../images/icons/MobileFooterIcons/account.svg';
import myApplication from '../../images/icons/MobileFooterIcons/myApplication.svg';
import homeIcon from '../../images/icons/MobileFooterIcons/homeIcon.svg';
import creditReport from '../../images/icons/MobileFooterIcons/creditReport.svg';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { navigate } from 'gatsby';
import useOutsideClick from '../../hooks/useOutsideClick';

let defaultFooterMenu = [
  {
    text: 'Home',
    icon: homeIcon,
    link: '/user/home'
  },
  {
    text: 'My Application',
    icon: myApplication,
    link: '/user/applications'
  },
  {
    text: 'Credit Report',
    icon: creditReport,
    link: '/user/request'
  },
  {
    text: 'Account',
    icon: account,
    link: '/user/changepassword'
  }
];
function MobileFooter({ passFooterMenu = false }) {
  const [moreOptions, setMoreOptions] = useState(false);
  const [activeMenu, setActiveMenu] = useState('');
  const extraFooterRef = useRef(null);

  const isClickedOutside = useOutsideClick(extraFooterRef);

  useEffect(() => {
    if (isClickedOutside) {
      setMoreOptions(false);
    }
  }, [isClickedOutside]);

  let finalFooterMenu = [];
  if (!passFooterMenu) {
    finalFooterMenu = defaultFooterMenu;
  } else {
    finalFooterMenu = passFooterMenu;
  }

  useEffect(() => {
    const indexItem = finalFooterMenu?.findIndex(elem => {
      return location?.pathname?.includes(elem?.link);
    });

    if (indexItem !== -1) {
      setActiveMenu(finalFooterMenu[indexItem]?.link);
    } else {
      setActiveMenu('/user/home');
    }
  }, [location?.pathname]);

  let extraMenu = false;
  if (finalFooterMenu?.length > 4) {
    extraMenu = true;
  }

  return (
    <div className="block md:hidden mt-16">
      <div
        className="w-full z-20 bg-white fixed bottom-0 py-3 px-4"
        style={{ boxShadow: '0px 0px 3px #d5c9c9' }}
      >
        <div className="flex justify-around">
          {finalFooterMenu?.map((each, index) => {
            return (
              <CommonFooterMenu
                key={index}
                passIcon={each?.icon}
                passText={each?.text}
                passLink={each?.link}
                showDot={extraMenu && index >= 3}
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
              />
            );
          })}

          {extraMenu && (
            <div
              className="relative cursor-pointer"
              style={{
                top: '10px'
              }}
              onClick={e => {
                setMoreOptions(!moreOptions);
              }}
            >
              <MoreHorizIcon />
              {moreOptions && (
                <div
                  ref={extraFooterRef}
                  className="absolute bg-white shadow rounded p-3"
                  style={{
                    right: '0px',
                    bottom: '40px',
                    minWidth: '160px',
                    maxWidth: '170px'
                  }}
                >
                  {finalFooterMenu?.slice(3)?.map((each, index) => {
                    return (
                      <div>
                        {extraMenu && (
                          <div
                            onClick={e => {
                              setMoreOptions(false);
                              setActiveMenu(each?.link);
                              navigate(each?.link);
                            }}
                            key={index}
                            className="flex items-center pb-2"
                          >
                            <img
                              src={each?.icon}
                              alt=""
                              className="pr-2"
                              style={{
                                filter:
                                  activeMenu === each?.link ||
                                  location?.pathname?.includes(each?.link)
                                    ? ''
                                    : 'grayscale(1)'
                              }}
                            />
                            <p
                              className={`text-sm ${
                                activeMenu === each?.link ||
                                location?.pathname?.includes(each?.link)
                                  ? 'text-tealCol-100'
                                  : 'text-black-600'
                              }`}
                            >
                              {each?.text}
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function CommonFooterMenu({
  passIcon,
  passText,
  passLink,
  showDot,
  activeMenu,
  setActiveMenu
}) {
  return (
    <>
      {!showDot && (
        <div
          onClick={e => {
            setActiveMenu(passLink);
            navigate(passLink);
          }}
          className="flex flex-col items-center justify-between"
        >
          <img
            src={passIcon}
            alt=""
            style={{
              filter:
                activeMenu === passLink ||
                location?.pathname?.includes(passLink)
                  ? ''
                  : 'grayscale(1)'
            }}
          />
          <div
            className={`text-xs ${
              activeMenu === passLink || location?.pathname?.includes(passLink)
                ? 'text-tealCol-100'
                : 'text-black-600'
            }`}
          >
            {passText}
          </div>
        </div>
      )}
    </>
  );
}
export default MobileFooter;
